<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="取消预约"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div v-if="!canceled" style="width: 100%; height: 100%">
        <div style="width: 100%; height: 100%">
          <div style="height: 1.375rem"></div>
          <div class="item-parent first">
            <div class="appointment-info-hint">预约信息</div>
            <div class="imaginary-line"></div>
            <div class="appointment-time">{{ showTime }}</div>
            <div class="appointment-address">
              {{ typeName }} {{ buildingNo }} {{ roomNo }}
            </div>
            <div class="appointment-hour">预约时长：{{ showDuration }}</div>
          </div>

          <div class="item-parent bottom">
            <div class="cancel-explain-title">取消预约说明</div>
            <div class="cancel-explain-content">
              <div>1.取消预约不限次、不扣除时长。</div>
              <div>2.取消预约后，预约无法恢复，请谨慎操作。</div>
            </div>
          </div>
        </div>
        <!-- <div class="back-first" @click="backFirst">返回首页</div> -->
        <div class="confirm-cancel" @click="confirmCancel">确认取消</div>
      </div>
      <div v-else style="width: 100%; height: 100%">
        <div style="width: 100%; height: 100%">
          <div style="height: 1.375rem"></div>
          <div class="item-parent first">
            <div class="canceled-hint">已取消</div>
            <div class="imaginary-line"></div>
            <div v-if="computationUnfold" class="computation-time">
              <div class="computation-time-hint">预约时长</div>
              <div class="computation-time-num">{{ showDuration }}</div>
            </div>
            <div v-if="computationUnfold" class="computation-time">
              <div class="computation-time-hint">扣除时长</div>
              <div class="computation-time-num">-{{ deductTime }}</div>
            </div>
            <div v-if="computationUnfold" class="imaginary-line"></div>
            <div class="canceled-send-back-parent">
              <div class="canceled-send-back-hint">退回时长：</div>
              <div class="canceled-send-back-time-num">{{ sendBackTime }}</div>
              <img
                class="expand-shrink"
                @click="expandShrinkComputation"
                :src="
                  computationUnfold
                    ? require('../../assets/imgs/shrink.png')
                    : require('../../assets/imgs/expand.png')
                "
              />
            </div>
          </div>
          <div class="item-parent">
            <div class="appointment-time">{{ showTime }}</div>
            <div class="appointment-address">{{ address }}</div>
          </div>
          <div class="item-parent bottom">
            <div class="canceled-cancel-explain-parent">
              <div class="canceled-cancel-explain-title">取消预约说明</div>
              <img
                class="expand-shrink"
                @click="expandShrinkExplain"
                :src="
                  explainUnfold
                    ? require('../../assets/imgs/shrink.png')
                    : require('../../assets/imgs/expand.png')
                "
              />
            </div>
            <div v-if="explainUnfold" class="cancel-explain-content">
              <div>1.取消预约不限次、不扣除时长。</div>
              <div>2.取消预约后，预约无法恢复，请谨慎操作。</div>
            </div>
          </div>
        </div>
        <div class="back-first" @click="backFirst">返回首页</div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'

import { Toast, Dialog } from 'vant'

export default {
  data () {
    return {
      startEndTimeExplain: '',
      bookId: '',
      roomId: '',
      buildingNo: '',
      roomNo: '',
      typeName: '',
      duration: '',
      startTime: null,
      endTime: null,
      showTime: '',
      address: '',
      deductTime: '', // 扣除时间
      sendBackTime: '', // 退回时间
      canceled: false,
      computationUnfold: false,
      explainUnfold: false,
      options: {}
    }
  },
  mounted () {
    const option = this.$route.query
    this.options = option
    let startTime = decodeURIComponent(option.startTime)
    let endTime = decodeURIComponent(option.endTime)

    startTime = utils.formatDate(startTime)
    endTime = utils.formatDate(endTime)
    const showTime = utils.formatTimeMDChinese(startTime) + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeHourMinutes(endTime)
    //  this.startEndTimeExplain: app.globalData.startEndTimeExplain,
    this.bookId = option.bookId
    this.roomId = option.roomId
    this.buildingNo = option.buildingNo
    this.duration = option.duration
    this.showDuration = this.transformationHour(option.duration)
    this.roomNo = decodeURIComponent(option.roomNo)
    this.typeName = decodeURIComponent(option.typeName)
    this.startTime = startTime
    this.endTime = endTime
    this.showTime = showTime
  },
  computed: {

  },
  methods: {
    expandShrinkComputation () {
      this.computationUnfold = !this.computationUnfold
    },
    expandShrinkExplain () {
      this.explainUnfold = !this.explainUnfold
    },
    backFirst () {
      this.$router.replace('/my')
    },
    confirmCancel () {
      Dialog.confirm({
        title: '确认取消预约',
        message: '取消预约之后将无法恢复'
      }).then(() => {
        // on close
        const para = {
          room_id: this.options.roomId,
          book_id: this.options.bookId
        }
        api
          .axiosRequest(api.urlList.cancelReservedPiano, para)
          .then((res) => {
            if (res.code === common.resCode.OK) {
              Dialog.alert({
                title: '取消成功',
                message: '取消预约成功'
              }).then(() => {
                // on close
                // this.onClickLeft()
              })
              this.canceled = true
              let deductTime = Math.round(Number(this.duration) * 60) - Math.round(Number(res.hour) * 60)
              deductTime = this.transformationHour(deductTime / 60)
              this.deductTime = deductTime
              this.sendBackTime = this.transformationHour(res.hour)
            } else {
              Toast.fail('取消预约失败')
            }
          })
          .catch((e) => {
            console.log('error log:', e)
          })
      }).catch(() => {

      })
    },
    showDuration () {
      Toast.success('')
    },
    transformationHour (allhour) {
      if (allhour) {
        const hour = Number.parseInt(allhour)
        const minute = Math.round(allhour % 1 * 60)
        allhour = ''

        if (hour > 0) {
          allhour += hour + '小时'
        }
        if (minute > 0) {
          allhour += minute + '分钟'
        }
        if (!allhour) {
          allhour = 0
        }
      } else {
        allhour = 0
      }
      return allhour
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang='scss'>
.content_box {
  .item-parent {
    margin: 0.75rem 0.875rem 0 0.875rem;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-radius: 0.375rem;
    background-color: #fff;
    padding: 0 0.75rem 0 0.75rem;
  }
  .item-parent.first {
    margin-top: 0px;
  }
  .item-parent.bottom {
    margin-bottom: 4.6875rem;
  }
  .appointment-info-hint {
    height: 3.625rem;
    line-height: 3.625rem;
    font-size: 1.375rem;
    color: #1a91ff;
  }
  .imaginary-line {
    width: 20.25rem;
    height: 1px;
    border-bottom: 1px dashed #d4d4d4;
  }
  .appointment-time {
    margin-top: 0.75rem;
    font-size: 1.125rem;
    font-weight: 550;
    color: #333;
  }
  .appointment-address {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    font-weight: 550;
    color: #666;
  }
  .appointment-hour {
    font-size: 0.875rem;
    color: #666;
    margin-top: 1.25rem;
    margin-bottom: 1.125rem;
  }
  .cancel-time-hint {
    height: 3.625rem;
    line-height: 3.625rem;
    font-size: 1.375rem;
    color: #1a91ff;
  }
  .computation-time {
    height: 2.875rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .computation-time-hint {
    font-size: 32rpx;
    color: #333;
  }
  .computation-time-num {
    font-size: 1rem;
    color: #333;
  }
  .send-back-parent {
    height: 3.75rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  .send-back-hint {
    font-size: 1rem;
    color: #666;
  }
  .send-back-time-num {
    font-size: 1.25rem;
    font-weight: 550;
    color: #ff6d00;
  }
  .cancel-explain-title {
    height: 3.5625rem;
    line-height: 3.5625rem;
    color: #333;
    font-size: 1.125rem;
  }
  .cancel-explain-content {
    margin: 0px 0 0.9375rem 0;
    font-size: 0.625rem;
    color: #666;
    letter-spacing: 1px;
    line-height: 0.9375rem;
  }
  .confirm-cancel {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3.75rem;
    line-height: 3.75rem;
    text-align: center;
    background-color: #007dff;
    font-size: 1.25rem;
    font-weight: 550;
    color: #fff;
  }
  .canceled-hint {
    height: 3.625rem;
    line-height: 3.625rem;
    font-size: 1.375rem;
    color: #1a91ff;
  }
  .canceled-send-back-parent {
    height: 3.75rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .canceled-send-back-hint {
    font-weight: 550;
    font-size: 1rem;
    color: #333;
  }
  .canceled-send-back-time-num {
    flex-grow: 1;
    font-size: 1rem;
    font-weight: 550;
    color: #ff6d00;
  }
  .expand-shrink {
    box-sizing: border-box;
    width: 1.5625rem;
    height: 1.125rem;
    padding: 0.3125rem;
    margin-right: 0.5rem;
  }
  .canceled-cancel-explain-parent {
    height: 3.5625rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .canceled-cancel-explain-title {
    color: #333;
    font-size: 1.125rem;
  }
  .back-first {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3.75rem;
    line-height: 3.75rem;
    text-align: center;
    background-color: #007dff;
    font-size: 1.25rem;
    font-weight: 550;
    color: #fff;
  }
}
</style>
